<script lang="ts">
    
    import { fly } from "svelte/transition";
    import { onDestroy } from "svelte";
    import type { Game } from "../../Model/Game";
    import { SubscriptionsManager } from "../../Model/SubscriptionsManager";
    import AspectKeeper from "../Shared/AspectKeeper.svelte";
    import GameCard from "./GameCard.svelte";

    export let game: Game;
    export let tail: number = 2;

    const gameSubscriptions = new SubscriptionsManager();

    let lastNumbers: number[] = [];

    $: setupGame(game);

    onDestroy(() => gameSubscriptions.unsubscribeAll());

    function setupGame(game: Game): void {
        gameSubscriptions.unsubscribeAll();
        if (!game) {
            lastNumbers = [];
            return;
        }
        gameSubscriptions.subscribe(game.numbers, numbers => {
            lastNumbers = numbers.slice(-(tail + 1)).reverse();
        });
    }

</script>

<AspectKeeper ratio={1.4}>
    <div class="game-historic font-bingo-number" style="--tail: {1 / tail};">
        {#each lastNumbers as number (number)}
            <div class="number" in:fly={{ y: -100 }} out:fly={{ y: 100 }}>
                <GameCard {number} gameType={game.type} />
            </div>
        {/each}
    </div>
</AspectKeeper>

<style lang="scss">

    .game-historic {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .number {
        position: absolute;
        left: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 0.3s;

        :global(img) {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .number:nth-child(1) {
        height: 70%;
        top: 0;
        z-index: 5;
    }

    @for $i from 2 through 4 {
        .number:nth-child(#{$i}) {
            height: 30%;
            top: 70%;
            width: calc(100% * var(--tail));
            left: calc(100% * var(--tail) * #{$i - 2});
        }
    }

    .number:nth-child(5) {
        height: 30%;
        top: 70%;
        width: 33.33%;
        left: 66.66%;
    }
    

</style>
